{
  "DeleteReminder": "Borrar recordatorio",
  "DismissAlert": "Descartar",
  "DismissAllReminders": "Descartar todos los recordatorios",
  "DismissReminder": "Descartar recordatorio",
  "EditReminder": "Editar recordatorio",
  "RemindMe15Min": "Recordatorio en 15 minutos",
  "RemindMe5Min": "Recordatorio en 5 minutos",
  "RemindMe60Min": "Recordatorio en una hora",
  "RemindMeTomorrow": "Recordatorio mañana",
  "Reminder": "Recordatorio",
  "Reminders": "Recordatorios",
  "Snooze": "Recordarme"
}
